import React from "react";
import { Box, Typography, Paper } from "@mui/material";

const reports = [
  {
    id: 1,
    title: "Blood Test Report",
    date: "2025-06-01",
    doctor: "Dr. Sarah Johnson",
  },
  {
    id: 2,
    title: "MRI Scan Result",
    date: "2025-05-28",
    doctor: "Dr. Amit Verma",
  },
];

const ReportsPage = () => (
  <Box sx={{ padding: "2rem" }}>
    <Typography variant="h5">My Reports</Typography>
    <Typography variant="body1" color="text.secondary" gutterBottom>
      View and download your test and scan reports.
    </Typography>

    <Box mt={3}>
      {reports.length === 0 ? (
        <Typography>No reports available.</Typography>
      ) : (
        reports.map((report) => (
          <Paper key={report.id} sx={{ p: 2, mb: 2 }}>
            <Typography variant="subtitle1" fontWeight={600}>
              {report.title}
            </Typography>
            <Typography variant="body2">Date: {report.date}</Typography>
            <Typography variant="body2">Doctor: {report.doctor}</Typography>
          </Paper>
        ))
      )}
    </Box>
  </Box>
);

export default ReportsPage;
